const getMyRequestsLink = () => {
    return `${window.SAC_BASE_URL}/requests`;
};

export { getMyRequestsLink };
